import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Card, CardTitle, DeliveryMethodSelector, DeliveryRegionInfo, Loading } from '@reveni-io/reveni-ui'

import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'

import useShippingAddress from '../hooks/useShippingAddress/useShippingAddress'
import DeliveryMethodInfoDrawer from './DeliveryMethodInfoDrawer/DeliveryMethodInfoDrawer'
import useDeliveryMethodInfoDrawer from './hooks/useDeliveryMethodInfoDrawer/useDeliveryMethodInfoDrawer'
import useRegion from './hooks/useRegion/useRegion'
import RegionDrawer from './RegionDrawer/RegionDrawer'

const DeliveryMethodsCard = ({
  currency,
  loading,
  deliveryMethods,
  deliveryMethod,
  getDeliveryMethods,
  onClickDeliveryMethod,
  onSelectTimeRange,
  onSelectPickupDate,
  onSaveDeliveryMethod,
  specialConstraints,
  changeNumberOfReturnLabels,
  numberOfReturnLabels,
  maxNumberOfReturnLabels,
  addingDeliveryMethod,
}) => {
  const { t } = useTranslation()
  const { rmaInfo } = useContext(RMAContext)
  const { updateAddress } = useShippingAddress()
  const { showDeliveryMethodInfoDrawer, closeDeliveryMethodInfoDrawer, openDeliveryMethodInfoDrawer } =
    useDeliveryMethodInfoDrawer()

  const {
    showRegionDrawer,
    openRegionDrawer,
    closeRegionDrawer,
    onChangeRegion,
    provinces,
    selectedCountry,
    selectedProvince,
    getSelectedProvince,
    disabledChangeRegion,
  } = useRegion()

  const handleClickDeliveryMethod = deliveryMethodId => {
    onClickDeliveryMethod(deliveryMethodId)
    openDeliveryMethodInfoDrawer()
  }

  const handleChangeRegion = async regionId => {
    await getDeliveryMethods({ orderId: rmaInfo?.orderInfo?.id, regionId, returnId: rmaInfo?.orderInfo?.returnId })
    onChangeRegion(regionId)
  }

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Métodos de devolución')}</CardTitle>
      <Loading show={loading} height="350px">
        <DeliveryRegionInfo
          onClick={openRegionDrawer}
          region={`${getSelectedProvince()} ${selectedCountry?.name}`}
          disableChange={disabledChangeRegion}
        />
        <DeliveryMethodSelector
          methods={deliveryMethods}
          onChange={handleClickDeliveryMethod}
          deliveryMethodSelected={rmaInfo?.orderInfo?.deliveryMethod}
          currency={currency}
          showVisibilityInternalChip
        />
        <RegionDrawer
          show={showRegionDrawer}
          onClose={closeRegionDrawer}
          provinces={provinces}
          onChangeRegion={handleChangeRegion}
          selectedCountry={selectedCountry?.name}
          selectedProvince={selectedProvince}
        />
        <DeliveryMethodInfoDrawer
          show={showDeliveryMethodInfoDrawer}
          onClose={closeDeliveryMethodInfoDrawer}
          deliveryMethod={deliveryMethod}
          onSelectTimeRange={onSelectTimeRange}
          onSelectPickupDate={onSelectPickupDate}
          onSave={onSaveDeliveryMethod}
          updateAddress={updateAddress}
          specialConstraints={specialConstraints}
          changeNumberOfReturnLabels={changeNumberOfReturnLabels}
          numberOfReturnLabels={numberOfReturnLabels}
          maxNumberOfReturnLabels={maxNumberOfReturnLabels}
          addingDeliveryMethod={addingDeliveryMethod}
        />
      </Loading>
    </Card>
  )
}

export default DeliveryMethodsCard
